<mat-progress-bar class="m-b-20" mode="indeterminate" color="accent" *ngIf="showLoader"></mat-progress-bar>
<div class="container">
<h3>{{popup.title}}</h3>
<h5>{{popup.subTitle}}</h5>
<!--{{popup.patient.name}}-->
<form (ngSubmit)="onSubmit()" [formGroup]="movePatientForm" class="movePatient">
  <mat-form-field appearance="outline">
    <mat-select placeholder="Select Dashboard" class="m-b-12" (selectionChange)="getAllQueues()" [formControl]="movePatientForm.controls['dashboardId']">
      <mat-option [value]="item.id" *ngFor="let item of allBoards">{{item.boardName}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-select placeholder="Select Queue" class="m-b-12" [formControl]="movePatientForm.controls['queueId']">
      <mat-option [value]="item.id" *ngFor="let item of allQueues">{{item.queueName}}</mat-option>
    </mat-select>
  </mat-form-field>
  <button class="m-b-15" color="primary" mat-raised-button type="submit">Submit</button>
</form>
</div>